var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8571 6.90909H9.71429C9.08343 6.90909 8.57143 7.39782 8.57143 8C8.57143 8.60218 9.08343 9.09091 9.71429 9.09091H22.8571C23.488 9.09091 24 8.60218 24 8C24 7.39782 23.488 6.90909 22.8571 6.90909ZM24 1.09091C24 0.488727 23.488 0 22.8571 0H1.14286C0.512 0 0 0.488727 0 1.09091C0 1.69309 0.512 2.18182 1.14286 2.18182H22.8571C23.488 2.18182 24 1.69309 24 1.09091ZM22.8571 13.8182H6.85714C6.22629 13.8182 5.71429 14.3069 5.71429 14.9091C5.71429 15.5113 6.22629 16 6.85714 16H22.8571C23.488 16 24 15.5113 24 14.9091C24 14.3069 23.488 13.8182 22.8571 13.8182Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/align_right.3fd784a94f9504e7f316ad96ef4b8514.svg";
export { ForwardRef as ReactComponent };